import React, { useState } from "react";
import { CUSTOMER_SUPPORT } from "src/utils/constants";
import { useDispatch, useSelector } from "react-redux";
import { openAuthModal } from "src/redux/slices/authSlice.js";
import Authpopup from "src/components/home/authpopup/Authpopup.js";
import { ConfirmationPopup } from "src/components/ui/popup/ConfirmationPopup.jsx";
import { showExpirePopup } from "src/redux/slices/sessionValidation.js";

const Header = () => {
  const dispatch = useDispatch();
  const auth = useSelector((state) => state.AuthSlice);
  const [menuOpen, setMenuOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);

  function handleMobileSignin() {
    setOpenConfirm(true);
  }

  function signButton() {
    dispatch(openAuthModal());
  }

  function toggleMenu() {
    setMenuOpen(!menuOpen);
  }

  function closeMenu() {
    setMenuOpen(false);
  }

  return (
    <>
      <Authpopup open={auth.isOpenSign} handleClose={() => {}} />
      <div className="container relative z-50">
        <ConfirmationPopup
          isOpen={openConfirm}
          onContinue={signButton}
          onClose={() => setOpenConfirm(false)}
          description="The Platform is not mobile responsive, Continue on web view ?"
        />
        <div className="flex justify-between items-center py-[20px] border-b-[1px] border-[#FF898A] ">
          <a href={"/"} alt="logo" className="logo">
            <img
              alt="home"
              src="/Image/home/travomint_partner.svg"
              width={234}
              className="max-[500px] w-[200px]"
            />
          </a>

          {/* Mobile Menu Icon */}
          <div className="hidden max-md:block">
            <button onClick={toggleMenu}>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={40}
                height={40}
                viewBox="0 0 24 24"
                fill="#272727"
              >
                <path d="M4 18q-.425 0-.712-.288T3 17t.288-.712T4 16h16q.425 0 .713.288T21 17t-.288.713T20 18zm0-5q-.425 0-.712-.288T3 12t.288-.712T4 11h16q.425 0 .713.288T21 12t-.288.713T20 13zm0-5q-.425 0-.712-.288T3 7t.288-.712T4 6h16q.425 0 .713.288T21 7t-.288.713T20 8z" />
              </svg>
            </button>
          </div>

          {/* Desktop Buttons */}
          <div className="flex items-center max-md:hidden">
            <a
              className="h-[42px] px-[1rem] border-[1px] !text-[#cb2b2c] duration-300 transition hover:shadow-md border-[#FF898A] text-[16px] font-[700] !text-[#272727] no-underline !rounded-[10px] inline-flex items-center justify-center"
              href={`tel:${CUSTOMER_SUPPORT}`}
            >
              {CUSTOMER_SUPPORT}
            </a>
            <div className="ml-3">
              <button
                onClick={signButton}
                className="w-[108px] h-[42px] border-[1px] duration-300 transition hover:shadow-md border-[#FF898A] text-[16px] font-[700] !text-[#272727] no-underline !rounded-[10px] inline-flex items-center justify-center"
              >
                <img
                  src="/Image/home/social_icon.svg"
                  className="inline-block mr-2"
                  alt="profile icon"
                />
                Sign In
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Mobile Sidebar */}
      <div
        className={`fixed top-0 left-0 h-full w-[280px] bg-white z-[999] shadow-lg transform ${
          menuOpen ? "translate-x-0" : "-translate-x-full"
        } transition-transform duration-300 ease-in-out max-md:block hidden`}
      >
        <div className="p-4 flex justify-between items-center border-b">
          <img alt="home" src="/Image/home/travomint_partner.svg" width={180} />
          <button onClick={closeMenu}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width={25}
              height={25}
              viewBox="0 0 24 24"
              fill="red"
            >
              <path d="M18.3 5.71a1 1 0 0 0-1.41 0L12 10.59 7.11 5.7A1 1 0 0 0 5.7 7.11L10.59 12l-4.89 4.89a1 1 0 1 0 1.41 1.41L12 13.41l4.89 4.89a1 1 0 0 0 1.41-1.41L13.41 12l4.89-4.89a1 1 0 0 0 0-1.4z" />
            </svg>
          </button>
        </div>

        <div className="p-4 flex flex-col gap-4">
          <a
            className="h-[42px] px-[1rem] border-[1px] !text-[#cb2b2c] duration-300 transition hover:shadow-md border-[#FF898A] text-[16px] font-[700] !text-[#272727] no-underline !rounded-[10px] inline-flex items-center justify-center"
            href={`tel:${CUSTOMER_SUPPORT}`}
          >
            {CUSTOMER_SUPPORT}
          </a>
          <button
            onClick={() => {
              handleMobileSignin();
              // signButton();
              // closeMenu();
            }}
            className="w-full h-[42px] border-[1px] duration-300 transition hover:shadow-md border-[#FF898A] text-[16px] font-[700] !text-[#272727] no-underline !rounded-[10px] inline-flex items-center justify-center"
          >
            <img
              src="/Image/home/social_icon.svg"
              className="inline-block mr-2"
              alt="profile icon"
            />
            Sign In
          </button>
        </div>
      </div>

      {/* Overlay */}
      {menuOpen && (
        <div
          onClick={closeMenu}
          className="fixed inset-0 bg-black bg-opacity-30 z-[998] max-md:block hidden"
        ></div>
      )}
    </>
  );
};

export default Header;
